import { createFileRoute } from "@tanstack/react-router";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";

export const Route = createFileRoute("/_app/content-enhancer")({
  component: () => (
    <div className="m-auto mt-10 flex w-8/10 flex-col items-center">
      <h1 className="text-2xl font-bold">
        Content Enhancer is only available in the full version of our web
        application
      </h1>
      <h2 className="text-l font-semibold">
        Please visit{" "}
        <a
          href="https://app.polygraf.ai/content-enhancer"
          target="_blank"
          rel="noreferrer"
          className="font-normal underline"
        >
          https://app.polygraf.ai/content-enhancer
        </a>{" "}
        to experience the Content Enhancer
      </h2>
    </div>
  ),
  async loader({ context: { queryClient } }) {
    await queryClient.prefetchQuery(userPlanQueryOptions);
  },
  staticData: {
    title: "Content Enhancer",
  },
  head: () => ({
    meta: [
      {
        name: "description",
        content:
          "Improve structure, style, and readability of any draft with Polygraf AI’s Content Enhancer - AI-powered suggestions to sharpen messaging and engagement, deployable in local or on-premises environments.",
      },
    ],
  }),
});
